'use client'

import { useMemo } from 'react'
import { useSession } from '@wiggot/auth/hooks/useSession'
import { GoogleIcon } from '@wiggui/ds/GoogleIcon'
import { composeClasses } from '../../../../utils/src/strings'
import { getFirstTwoLetters } from '../../../utils'
import { OLD_WIGGOT_URL } from '../../../constants'

interface IProfileButtonProps {
  variant: 'black' | 'white'
}
export const ProfileButton = ({ variant }: IProfileButtonProps) => {
  const { profile, authUser, roles } = useSession()
  const userName = profile?.fullname
  const isBlack = variant === 'black'

  const urlRedirectHome = useMemo(() => {
    if (authUser?.isSelectDevelop || Boolean(roles?.ASSOCIATION)) {
      return OLD_WIGGOT_URL
    }
    return `${window.location.origin}/home`
  }, [authUser, roles])

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={urlRedirectHome}
      className={composeClasses(
        'flex flex-row-reverse md:flex-row justify-between md:justify-end items-center gap-2 p-3 md:py-1 md:pr-1 md:pl-8 border rounded-[100px]',
        isBlack ? 'bg-black border-primary' : 'bg-white border-surface-strokes'
      )}
    >
      <div className="flex md:hidden justify-end">
        <GoogleIcon name="chevron_right" />
      </div>
      <div className="w-full flex justify-between items-center gap-2">
        <div className="flex items-center gap-2 flex-row-reverse md:flex-row max-w-[180px] md:max-w-[140px]">
          <div className="flex flex-col w-full">
            <p
              className={composeClasses(
                'text-base font-medium md:text-right first-letter:uppercase truncate text-ellipsis',
                isBlack ? 'text-white' : 'text-black'
              )}
            >
              {userName}
            </p>
            <p className="text-sm font-normal text-secondary">
              Entrar como asesor
            </p>
          </div>
        </div>
        <div className="hidden md:flex p-3 justify-center items-center rounded-full bg-surface-dark text-white text-sm font-semibold min-w-11 min-h-11 w-11 h-11">
          {getFirstTwoLetters(userName ?? '')}
        </div>
      </div>
    </a>
  )
}
